import { createFileRoute, redirect } from "@tanstack/react-router";

/** /login is what people type: 301 to /sign-in, query (and ?redirect=) kept. */
export const Route = createFileRoute("/login")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: `/sign-in${location.searchStr}`, statusCode: 301 });
  },
});
